// extracted by mini-css-extract-plugin
export default {"overflowHidden":"poster-editor-item-hyperlink-panel-module__overflowHidden--xb1Rm","suggestionsDropdown":"poster-editor-item-hyperlink-panel-module__suggestionsDropdown--L7IFh"};